export default function CardEffect() {
  return (
    <svg
      width="248"
      height="19"
      viewBox="0 0 248 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clipPath="url(#paint0_angular_386_3070_clip_path)"
        data-figma-skip-parse="true"
      >
        <g transform="matrix(0.0487309 0 0 0.00678967 66.7005 9.22371)">
          <foreignObject
            x={-1637.98}
            y={-1637.98}
            width={3275.97}
            height={3275.97}
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg, rgba(9, 9, 11, 1) 0deg, rgba(25, 37, 40, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
      </g>

      <rect
        x={0.5}
        width={132.401}
        height={18.4474}
        rx={9.22371}
        data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.035294119268655777,"g":0.035294119268655777,"b":0.043137256056070328,"a":1.0},"position":0.0},{"color":{"r":0.098039217293262482,"g":0.14509804546833038,"b":0.15686275064945221,"a":1.0},"position":1.0}]}'
      />

      <g
        clipPath="url(#paint1_angular_386_3070_clip_path)"
        data-figma-skip-parse="true"
      >
        <g transform="matrix(-0.0489356 0 0 0.00678967 181.021 9.22371)">
          <foreignObject
            x={-1637.98}
            y={-1637.98}
            width={3275.97}
            height={3275.97}
          >
            <div
              style={{
                background:
                  "conic-gradient(from 90deg, rgba(9, 9, 11, 1) 0deg, rgba(25, 37, 40, 1) 360deg)",
                height: "100%",
                width: "100%",
                opacity: 1,
              }}
            />
          </foreignObject>
        </g>
      </g>

      <rect
        width={132.957}
        height={18.4474}
        rx={9.22371}
        transform="matrix(-1 0 0 1 247.5 0)"
        data-figma-gradient-fill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.035294119268655777,"g":0.035294119268655777,"b":0.043137256056070328,"a":1.0},"position":0.0},{"color":{"r":0.098039217293262482,"g":0.14509804546833038,"b":0.15686275064945221,"a":1.0},"position":1.0}]}'
      />

      <defs>
        <clipPath id="paint0_angular_386_3070_clip_path">
          <rect x={0.5} width={132.401} height={18.4474} rx={9.22371} />
        </clipPath>
        <clipPath id="paint1_angular_386_3070_clip_path">
          <rect
            width={132.957}
            height={18.4474}
            rx={9.22371}
            transform="matrix(-1 0 0 1 247.5 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
